import React, { useContext, useEffect, useRef } from "react";
import { Form, Formik, FormikHelpers } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import { ERRORS, ONBOARDING_STEPS, VIEWS } from "../constants/user-info.const";
import PersonalInfoForm from "./user-forms/PersonalInfoForm";
import { getEmployee, updateEmployee } from "../../services/employeeService";
import { PersonalInfoFormFields } from "./models/user-interface";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../routing/Routing";
import Loader from "../common/Loader";
import { connect } from "react-redux";
import { setEmployeeDetails } from "../../store/actions/employee";
import { onboardingActions } from "../../store/actions/steps";
import { formSubmitErrorHandler } from "../../services/formService";
import store from "../../store";
import { formatDateYYMMDD, getDateWithTimeZone } from "../../utils/dateUtil";

function PersonalInfo(props) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { setViewName } = useContext(AppContext);
  const [isShowFooterLoader, setIsShowFooterLoader] = useState<boolean>(false);
  const mountedRef = useRef(true);

  const [formInitial, setFormInitial] = useState({
    first_name: "",
    middle_initial: "",
    last_name: "",
    email: "",
    date_of_birth: '',
    ssn: "",
  });
  const {
    employee: { version, two_percent_shareholder, has_ssn },
    setEmployeeData,
    isNavigateToNext,
  } = props;
  const navigate = useNavigate();

  const navigationToHomeAddress = () => {
    if (isNavigateToNext === false) return;
    setViewName(VIEWS.homeAddress);
    navigate("/" + VIEWS.homeAddress);
  };
  const updateCompletedStep = () => {
    store.dispatch({
      type: onboardingActions.UPDATE_ONBOARDING_STEPS,
      state: ONBOARDING_STEPS.personalInfo,
    });
  };
  const validationSchema = Yup.object({
    first_name: Yup.string().required(ERRORS.firstName),
    last_name: Yup.string().required(ERRORS.lastName),
    email: Yup.string()
      .email(ERRORS.validEmail)
      .max(255)
      .required(ERRORS.email),
    date_of_birth: Yup.date().required(ERRORS.dob),
    ...(!has_ssn ? { ssn: Yup.string().required('SSN is required') } 
    : { ssn: Yup.string() })
  });
  
  const setFormData = (data: PersonalInfoFormFields) => {
    setFormInitial({
      first_name: data.first_name,
      middle_initial: data.middle_initial ?? "",
      last_name: data.last_name,
      email: data.email,
      date_of_birth: getDateWithTimeZone(data.date_of_birth),
      ssn: data.ssn,
    });
  };
  useEffect(() => {
    setIsLoading(true);
    getEmployee()
      .then((response: any) => {
        if (!mountedRef.current) return null;
        if (response.status === 200) {
          setEmployeeData(response.data);
          setFormData(response.data);
        }
        setIsLoading(false);
      })
      .catch(() => {
        if (!mountedRef.current) return null;
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const onSubmit = (
    {
      first_name,
      middle_initial,
      last_name,
      email,
      date_of_birth,
      ssn,
    }: PersonalInfoFormFields,
    formHelpers: FormikHelpers<any>
  ) => {
    const data = {
      version: version,
      first_name,
      middle_initial,
      last_name,
      email,
      date_of_birth,
      two_percent_shareholder: two_percent_shareholder,
    };
    if (ssn) {
      data["ssn"] = ssn;
    }
    if(date_of_birth){
        data["date_of_birth"]  = formatDateYYMMDD(date_of_birth);
    }
   setIsShowFooterLoader(true);
    formSubmitErrorHandler(
      updateEmployee(data).then((response: any) => {  
      setIsShowFooterLoader(false);
        setEmployeeData(response.data);
        setFormData(response.data);
        navigationToHomeAddress();
        updateCompletedStep();
        formHelpers.resetForm();
      }),
      () => {
        setIsShowFooterLoader(false);
      },
      formHelpers.setFieldError
    );
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="personal-info user-details__content">
          <Formik
            initialValues={formInitial}
            enableReinitialize
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            innerRef={props.formRef}
          >
            {() => {
              return (
                <Form>
                  <div className="user-details--section">
                    <PersonalInfoForm />
                    {isShowFooterLoader && <Loader footerLoader={true}/>}
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  employee: state.employee.details,
  isNavigateToNext: state.navigationFromMenu.isNavigateToNext,
});

export default connect(mapStateToProps, {
  setEmployeeData: setEmployeeDetails,
})(PersonalInfo);
